// extracted by mini-css-extract-plugin
module.exports = {"game":"game_game__9z6WP","title":"game_title__2Plk7","descr":"game_descr__NScqT","image":"game_image__2FWFJ","button":"game_button__3ULVt"};